// extracted by mini-css-extract-plugin
export default {"p2":"style_p2__q7CDZ"};